import ContactUs from "../../components/contact/contactUs";

const FraudPrevention = () => {

    return (
        <div className="flex flex-col gap-12">


            <section className="home-container !bg-fraud-banner !h-[600px]  !bg-cover ">
                <div className="justify-center items-center flex flex-col gap-6 xs:!h-auto md:!h-auto xs:gap-16  xs:!pt-[120px] sm:!pt-[120px] md:!pt-[220px]  sm:!pb-[120px] xs:px-4 px-16 text-center sm:text-left">
                    <h1 className="text-6xl text-white font-semibold">Fraud prevention</h1>
                    <p className="text-white text-base">Fraud Prevention Alert: Protect Your Assets with Vizion LLC
                    </p>
                </div>

            </section>

            <div className=" px-16 pb-8 xs:px-4 space-y-4 ">
                <h5 className="text-black text-xl">
                    At Vizion LLC, we prioritize the security of your transactions, especially when converting your gift cards into valuable assets like Bitcoin. While our services offer speed and convenience, we are committed to safeguarding our users from potential fraud.
                </h5>
                <h5 className="text-black text-xl font-bold">Stay Informed to Stay Secure:
                </h5>

                <h5 className="text-black text-xl">
                    1. Be Wary of Strangers:
                    <ul className=" pl-6">
                        <li className="li text-xl">
                            Never share your card details with unknown individuals.
                        </li>
                        <li className="li">Fraudsters can reach out through various channels, including phone calls, SMS, email, and social media.</li>
                    </ul>

                </h5>

                <h5 className="text-black text-xl">
                    2. Confidence Tricks:

                    <ul className=" pl-6">
                        <li className="li text-xl">
                            Fraudsters often use convincing stories to gain trust.

                        </li>
                        <li className="li">Avoid purchasing prepaid gift cards for anyone you don't personally know and trust.</li>
                    </ul>

                </h5>


                <h5 className="text-black text-xl font-bold">
                    Educational Resources:
                    </h5>

                    <h5 className="text-black text-xl">Familiarize yourself with common scams:
                    </h5>

                    <ul className=" pl-6 text-xl">
                        <li className="li ">
                            Romance Scam (FTC)

                        </li>
                        <li className="li">IRS/Tax Extortion (FTC)
                        </li>
                        <li className="li">Lottery Scams (FTC)
                        </li>
                        <li className="li">Phishing (FTC)</li>
                        <li className="li">Advance-fee Scams</li>
                        <li className="li">Technical Support Scams (FTC)</li>
                        <li className="li">Scams Targeting Seniors (FTC)</li>
                    </ul>

                    <h5 className="text-black text-xl font-bold">
                    How to Report Fraud:
                    </h5>

                    <h5 className="text-black text-xl">If you suspect fraudulent activity involving Vizion LLC Exchange, please contact us immediately. Your prompt reporting is crucial to addressing any issues effectively.

                    </h5>
                    <h5 className="text-black text-xl font-bold">
                    Additional Resources:

                    </h5>

                    <h5 className="text-black text-xl">
                    Stay informed and protect yourself by exploring these resources:

                    </h5>
                    <ul className=" pl-6 text-xl">
                        <li className="li text-blue ">
                           <a target="_blank" href="https://www.google.com/url?q=https://www.consumer.ftc.gov/scam-alerts&sa=D&source=docs&ust=1701434136337973&usg=AOvVaw1R2A1QUl0erCh3IknQ_I_9">Federal Trade Commission (FTC)</a> 

                        </li>
                        <li className="li text-blue ">
                        <a target="_blank" href="https://www.irs.gov/newsroom/tax-scamsconsumer-alerts"></a> Internal Revenue Service (IRS) - Tax Scams & Consumer Alerts


                        </li>
                        <li className="li text-blue ">
                        <a target="_blank" href="https://www.fbi.gov/scams-and-safety/common-scams-and-crimes"></a> Federal Bureau of Investigation (FBI) - Common Scams & Crimes


                        </li>
                        </ul>

                        <h5 className="text-black text-xl">
                        Your security matters to us. Together, let's create a safer environment for financial transactions.


                    </h5>

                    <h5 className="text-black text-xl"> 
                    Vizion LLC Team

                    </h5>

                    <h5 className="text-black text-xl"> 
                    Contact Us:


                    </h5>

                    <ul className=" pl-6 text-xl">
                        <li className="li text-blue ">
                           <a href="https://vizioncrypto.com/?tab=contactUs">Contact Form</a> 
                        </li>
                        <li className="li">Email: support@lbdigital.info </li>
                        <li className="li">Customer Service Number: 4075368162 
</li>
                        </ul>
                    



            </div>
            <ContactUs />
        </div>


    )
}
export default FraudPrevention;